"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
require("@hotmart/cosmos/dist/form/input-validate.css");
const InputError = ({ error }) => {
    if (!error) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback _d-block", children: error });
};
exports.default = InputError;
